import script from "./configFiles2.vue?vue&type=script&setup=true&lang=ts"
export * from "./configFiles2.vue?vue&type=script&setup=true&lang=ts"

import "./configFiles2.vue?vue&type=style&index=0&id=4a9911d2&lang=less&scoped=true"

import exportComponent from "/root/djmesweb-pc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a9911d2"]])

export default __exports__